import { render, staticRenderFns } from "./instrucao.vue?vue&type=template&id=5beb8d9c&scoped=true&"
import script from "./instrucao.vue?vue&type=script&lang=js&"
export * from "./instrucao.vue?vue&type=script&lang=js&"
import style0 from "./instrucao.vue?vue&type=style&index=0&id=5beb8d9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5beb8d9c",
  null
  
)

export default component.exports